<!--
 * @Author: Gaho
 * @Date: 2024-03-20 10:49:03
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-11 14:45:14
 * @Description: 
-->
<template>
    <div class="message">
        <div
            class="notification notification-link"
            v-for="(item, index) in notificationsList"
            :key="index"
            :style="{ 'top': 10 * (index + 1) + 'px', 'z-index': 99 - index }"
            @click.self="handleToHref(item)"
            :class="{ 'close-transition': item._id === currentId }"
        >
            <div class="notification-container" @click="handleToHref(item)">
                <div class="notification-icon">
                    <span class="icon-content">
                        {{ item.image }}
                    </span>
                </div>
                <div class="notification-content">
                    <p class="notification-title line-clamp-2">
                        {{ item.title }}
                    </p>
                    <p class="notification-sub-title line-clamp-5">
                        {{ item.text }}
                    </p>
                </div>
            </div>
            <!-- ↓关闭按钮 -->
            <Button class="btn-close" @click="() => handleBtnClose(item)">
                <IconSvgUse
                    size="25px"
                    use="icon-close"
                />
            </Button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useNotificationSocket } from '@/socket/notifications/index';
import { type NotificationsParams, type NotificationsDataType } from '@/socket/notifications/dto/index';

const action = ref(null);
const currentId = ref(null);
const notificationsList = ref([]);

// 监听数据变化，并开启计时器，等到dateTo后关闭提示框
watch(
    () => notificationsList.value.length,
    (newVal, oldVal) => {
        const newsCame = newVal > oldVal;
        if (!newsCame) return; 
        console.log(`消息来了 ${oldVal} -->`, newVal); 
        for (let i = oldVal; i < newVal; i++) {
            const current = notificationsList.value[i];
            // 原站点是通过new Date(current.dateTo).getTime() - Date.now()设置推送消息显示时长的
            // 目前改为使用displayTime
            // displayTime 展示时长：0-15s（0即为一直展示，若不手动关闭的话。其余时间为自动关闭）
            handleSetTimeout(current._id, current.displayTime * 1000);
        }
    },
);

/**
 * 管理提示框自动关闭
 */
const handleSetTimeout = (id: string, delay: number) => {
    const current = notificationsList.value.find((item) => item._id === id);
    // console.log(id, delay, 'handleSetTimeout');
    if (delay) {
        setTimeout(() => {
            action.value = 'auto-closed';
            handleClose({
                action: action.value,
                id: id,
                isPersonal: !!current.isPersonal,
            });
        }, delay);
    }
};

/**
 * 关闭通知
 * @param {NotificationsParams} params 当前通知项数据
 */
const handleClose = async (params: NotificationsParams) => {
    currentId.value = params.id;
    // await Sleep(300);
    currentId.value = null;
    console.log('正在关闭：', deepCopy(params)); 
    const { EMIT_NOTIFICATIONS_MARK } = useNotificationSocket();
    EMIT_NOTIFICATIONS_MARK(params, (res: null) => {
        console.log(res, 'EMIT_NOTIFICATIONS_MARK');
        // emits('handleCloseNotif', params.id);
        handleCloseNotif(String(params.id)); 
    });
};

/**
 * 点击关闭按钮 关闭提示框
 */
const handleBtnClose = (item) => {
    console.log('点击关闭：', deepCopy(item)); 
    action.value = 'closed';
    handleClose({
        action: action.value,
        id: item._id,
        isPersonal: !!item.isPersonal,
    });
};

/**
 * 跳转链接
 */
const handleToHref = (item) => {
    console.log('查阅消息：', deepCopy(item));  
    const { href } = item;
    if (!href) return;
    // 完整路径
    if (/^http/.test(href)) {
        window.open(href, '_blank').focus();
    } else {
        // 路由跳转
        const router = useRouter();
        router.push(href);
    }
    action.value = 'followed';
    handleClose({
        action: action.value,
        id: item._id,
        isPersonal: !!item.isPersonal,
    });
};

// -------- ↓ 从首页移动到此的 --------------------------------------------------------------  

/**
 * 获取message推送消息列表
 */
const onNotificationsList = async () => {
    const { ON_NOTIFICATIONS_LIST } = useNotificationSocket();
    // 获取推送消息列表
    ON_NOTIFICATIONS_LIST((res: Array<NotificationsDataType>) => {
        notificationsList.value = notificationsList.value.concat(res);
    });
    // ↓ 仅用于测试 
    // if (!import.meta.dev) return;
    // const {notificationsData} = await import('@/components/Modal/Message/data/index');
    // notificationsList.value = notificationsData;
    // setTimeout(() => {
    //     const oNewOne = deepCopy(notificationsData[0]);
    //     oNewOne.title = `order = ${1 + notificationsList.value.length} 🚩🚩🚩`; 
    //     notificationsList.value.push(oNewOne);
    //     console.log('消息列表 ↓\n', deepCopy(notificationsData)); 
    // }, 3_000);
};

/**
 * 点击关闭当前推送消息
 * @param id 推送消息id
 */
const handleCloseNotif = (id: string) => {
    const index = notificationsList.value.findIndex((item) => item._id == id);
    if (index < 0){
        console.log(`关闭消息：${id}`); 
        return console.warn('关闭消息未成功：', deepCopy(notificationsList.value)); 
    }
    notificationsList.value.splice(index, 1);
};

onMounted(()=>{
    onNotificationsList(); 
});

</script>

<style lang="scss" scoped>
.message {
    --notifications-color_notification-bg: #212d3f;
    max-width: min(350px, calc(100vw - 20px));
    padding: 0;
    position: fixed;
    // right: 52px;
    right: 12px;
    top: 76px;
    width: 100%;
    z-index: 8000;
    @media (max-width: 768px) {
        right: 10px;
    }

    .notification {
        background-color: var(--notifications-color_notification-bg);
        border-radius: 14px;
        box-shadow: 0 8px 16px #0d131ca3;
        overflow: hidden;
        position: absolute;
        width: 100%;
        transition: all 0.3s ease-in-out;
        &:hover {
            background-color: #253246;
        }
        .notification-container {
            display: grid;
            grid-template-columns: 56px 1fr;
            grid-column-gap: 15px;
            margin-right: 45px;
            padding: 10px 0 10px 10px;
            text-decoration: none;
            position: relative;
            z-index: 1;
            .notification-content{
                overflow: hidden;
            }
            .notification-icon {
                align-items: center;
                align-self: center;
                display: flex;
                grid-column: 1/2;
                grid-row: 1/2; // 旧值： 1/3 
                height: 56px;
                justify-content: center;
                justify-self: center;
                position: relative;
                width: 56px;
                border: 2px solid #2a3546;
                border-radius: 50%;
                .icon-progress {
                    bottom: -2px;
                    height: 56px;
                    left: -2px;
                    position: absolute;
                    right: -2px;
                    top: -2px;
                    width: 56px;
                    fill: #1bb83d;
                }
                .icon-content {
                    background-color: #0d131c;
                    border: none;
                    border-radius: 50%;
                    display: block;
                    font-size: 24px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    width: 44px;
                }
            }
            .notification-title,
            .notification-sub-title {
                align-self: center;
                font-weight: 500;
                grid-column: 2/3;
                margin: 0;
            }
            .notification-title {
                color: #fff;
                font-size: 14px;
                grid-row: 1/2;
            }
            .notification-sub-title {
                margin: 5px 0 0; 
                color: #838fac;
                font-size: 11px;
                grid-row: 2/3;
            }
        }
        .btn-close {
            background-color: transparent;
            border: none;
            color: #788aa8;
            font-size: 36px;
            font-weight: 500;
            height: 45px;
            line-height: 45px;
            padding: 0;
            position: absolute;
            right: 0;
            top: 15px;
            transition: color 0.3s;
            width: 45px;
            z-index: 2;
            &:hover {
                color: #fff;
            }
        }
    }
    .notification-link {
        cursor: pointer;
        &::before {
            background: linear-gradient(
                90deg,
                #161f2c00 -9.17%,
                #0a58c63d 22.38%,
                #161f2c00 108.29%
            );
            bottom: 0;
            content: '';
            display: block;
            height: 100%;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            transform: translate(-100%);
            transition: transform 0.3s;
            width: 100%;
            z-index: 0;
        }
        &:hover:before {
            transform: translate(0);
        }
        .notification-title {
            color: #2283f6 !important;
            text-decoration: underline;
        }
    }
}
.close-transition {
    transform: translateX(110%);
    opacity: 0;
}
</style>